import script from "./SocialFundDocumentValidationDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialFundDocumentValidationDialog.vue?vue&type=script&setup=true&lang=js"

import "./SocialFundDocumentValidationDialog.vue?vue&type=style&index=0&id=c9ea2aca&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9ea2aca"]])

export default __exports__